<template>
    <div class="applyList">
        <div class="search_warp">
            <mSeacher :param="param" @getList="getList" :page="page"></mSeacher>
        </div>
        <pull :pull="pull" :page="page" @getList="getList">
            <NoData v-if="!dataList.length"></NoData>
            <div class="searchList" v-else>
                <div class="box" v-for="(obj) in dataList" :key="obj.eventid" @click="gotoView(obj)">
                    <div class="left"><img class="img" v-lazy="obj.eventlogo" alt=""></div>
                    <div class="right">
                        <div class="title">{{obj.title}}</div>
                        <div class="info">
                            <div class="tc-grey">{{obj.begintime}} - {{obj.endtime}}</div>
                            <div class="tc-grey">{{obj.areaname}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </pull>
    </div>
</template>

<script>
  import Pull from 'views/mobile/components/pull/pull'
  import NoData from 'views/mobile/components/noData/noData'
  import {getSearchList} from 'api/activeTools'
  import {mapGetters, mapActions} from 'vuex'
  import MSeacher from 'views/mapply/components/mSeacher.vue'

  export default {
    name: 'applyList',
    data() {
      return {
        dataList: [],
        page: {
          page: 1,
          pageSize: 10,
          pageCount: 0,
          rowCount: 0
        },
        pull: {
          isLoading: false,
          loading: false,
          error: false,
          finished: false
        },
        activeJobplace: this.$route.query.jobplace ? this.$route.query.jobplace : '',
        activeAnnualSalary: '',
        param: {
          city: '',
          feetype: '',
          status: '',
          key: decodeURI(this.$route.query.key) ? decodeURI(this.$route.query.key) : '',
          timetype: '',
        }
      }
    },
    mounted() {
      document.title = '搜索'
      this.setNoDataTip('暂无相关活动')
      this.getList()
    },
    methods: {
      gotoView(obj) {
        if (obj.enrolleventsource == 1) {
          this.setRefresh(true)
          this.$router.push({name: 'ActivityDetail', query: {eventid: obj.eventid}})
        } else {
          window.location.href = obj.enrolllinkurl
        }
      },
      getList() {
        this.setLoading(true)
        getSearchList({
          data: Object.assign({}, this.param, this.page),
          success: data => {
            if (this.page.page === 1) {
              this.pull.isLoading = false
              this.dataList = data.data.content
            } else {
              this.dataList = this.dataList.concat(data.data.content)
            }
            this.setLoading(false)
            this.pull.loading = false
            this.page.pageCount = data.data.pageinfo.pageCount
            this.page.rowCount = data.data.pageinfo.rowCount
            if (this.page.page === this.page.pageCount) {
              this.pull.finished = true
            }
          },
          error: data => {
            this.setLoading(false)
            this.pull.error = true
            this.pull.loading = false
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions([
        'setLoading',
        'setNoDataTip',
        'setRefresh'
      ])
    },
    filters: {},
    watch: {
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    },
    components: {Pull, NoData, MSeacher}
  }
</script>

<style lang="scss" type="text/scss">
    @import "~common/scss/variable";

    .applyList {
        min-height: 100vh;
        font-family: PingFangSC-Regular, PingFang SC;
        padding-top: 1.83rem;
        box-sizing: border-box;
        background: $c-global;
        .searchList{
            margin-top:0.2rem;
            padding: 0 0.32rem 0.16rem 0.32rem;
            background: $c-white;
            .box{
                display: flex;
                justify-content: flex-start;
                font-size:0.28rem;
                font-weight: 600;
                background: $c-white;
                padding: 0.16rem 0;
                .left{
                    min-width:3rem;
                    max-width:3rem;
                    width: 3rem;
                    height: 1.67rem;
                    margin-right:0.2rem;
                    .img{
                        width: 100%;
                        height: 100%;
                        border-radius: 0.04rem;
                    }
                }
                .right{
                    width: 4.65rem;
                    .title{
                        max-height: 0.8rem;
                        font-weight: 600;
                        line-height: 0.4rem;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .info{
                        margin-top: 0.12rem;
                        font-size: 0.24rem;
                        line-height: 0.32rem;
                    }
                }
            }
        }
        .noData{
            height: calc(100vh - 1.88rem);
            background: $c-white;
        }
        .noData {
            height: calc(100vh - 2.03rem);
            background: $c-white;
        }
    }
</style>